module.exports = __webpack_public_path__ + "static/media/backButton.eb12e1fd.svg";